export default {
    PROCESS_RES: (state, data) => {
        state.items = data.items.map(item => ({
            ...item,
            // place: Vue.filter('extendAddress')(item.place)
        }));
        state.pagination = {
            page: data.page || 1,
            totalPages: data.totalPages || 1,
            count: data.count || 0
        };
    }
};
